import Vue from 'vue'

import Qs from 'qs'

class Organizers {
  async suggest() {
    return await Vue.axios
      .get('app/organizers/suggest')
  }

  async index({params}) {
    return await Vue.axios
      .get('app/organizers', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/organizers', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/organizers/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/organizers/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/organizers/' + id)
  }
}

const organizers = new Organizers()

export default organizers
